import { Search } from 'lucide-react';
import { cn } from '@/lib/utils';
import { NATIVE_FIELD_CLASS } from '@/contabilidad/constants/ui';

interface SearchInputProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function SearchInput({ placeholder, value, onChange, className }: SearchInputProps) {
  return (
    <div className={cn('relative', className)}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={cn(NATIVE_FIELD_CLASS, 'pl-9')}
      />
    </div>
  );
}
